import { createRouter, createWebHistory } from 'vue-router'
import { isRouterReady } from '../main'
import getTokenInfo from '../api/auth'
import emitter from '../util/emitter.js'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: { name: 'AnalysisTrend' }
    },
    {
      path: '/analysis/trend',
      name: 'AnalysisTrend',
      component: () => import('@/views/analysis/TrendAnalysis/index.vue')
    },
    {
      path: '/analysis/architecture',
      name: 'AnalysisArchitecture',
      component: () => import('@/views/analysis/ArchitectureAnalysis/index.vue')
    },
    {
      path: '/analysis/module',
      name: 'AnalysisModule',
      component: () => import('@/views/analysis/ModuleAnalysis/index.vue')
    },
    {
      path: '/analysis/micro-journey',
      name: 'AnalysisMicroJourney',
      component: () => import('@/views/analysis/MicroJourneyAnalysis/index.vue')
    }
  ],
})

router.beforeEach(async (to, from, next) => {
  try {
    // 修正条件判断：仅在路由未准备好时执行一次
    if (!isRouterReady.value) { 
      await handleCodeParam();
      isRouterReady.value = true;
      next();
    } else {
      next();
    }
  } catch (error) {
    emitter.emit('http-error', {
      message: '页面已超时，请刷新后继续使用',
      code: error.code || 401 
    });
    console.warn('鉴权异常:', error);
    next(false);
  }
});

// 修改为异步函数，让路由守卫可以等待其完成
const handleCodeParam = async () => {
  const searchParams = new URLSearchParams(window.location.search);
  const code = searchParams.get('code');

  if (code) {
    localStorage.setItem('code', code);
  }

  // 等待获取Token信息，如果失败会抛出异常
  const res = await getTokenInfo();
  // 判断响应是否成功（code=200且success=true）
  if (res?.code !== 200 || !res?.success) {
    console.warn(res?.message)
    // 可以根据返回的message提供更具体的错误信息
    const errorMsg =  '页面已超时，请刷新后继续使用';
    throw new Error(errorMsg);
  }
};

// 错误处理函数保持不变
const handleHttpError = (event) => {
  ElMessage({
    message: event.message,
    grouping: true,
    type: 'error'
  })
  if (event.code === 4010) {
    // Token 过期重载页面
    window.location.reload()
  }
}
 

export default router
